import fly from './fly'
import { getAuth } from '@/util/storage'
const auth = getAuth()
export const fetchOrderRefund = (params: Object) =>
  fly.post('/mall/cs/order/applyCustomerService.json', { ...params, auth })
